export default __webpack_public_path__ + "static/media/img-15.f34ef2b1.png";